module.exports = __webpack_public_path__ + "img/menu_icon13.f874da13.png";